import React, { useState } from "react";
import { Typography } from "@mui/material";
import { ConfirmModal } from "../../components/ConfirmModal";
import CheckboxField from "../../components/CheckboxField";
import { saveHideSortModelConfirmState } from "../../utils/cookie";

interface ConfirmModelSortModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ConfirmModelSortModal: React.FC<ConfirmModelSortModalProps> = ({
  isOpen,
  onClose,
}) => {
  const [isChecked, setIsChecked] = useState(false);

  return (
    <ConfirmModal
      isOpen={isOpen}
      heading="Refresh"
      body={
        <>
          <Typography>
            Refresh the page to resort it with favorites at the top.
          </Typography>
          <CheckboxField
            size="small"
            label="Don’t show this again"
            checked={isChecked}
            onChange={(e) => {
              setIsChecked(e.target.checked);
              saveHideSortModelConfirmState(e.target.checked);
            }}
          />
        </>
      }
      confirmButtonText="Refresh"
      onConfirm={() => {
        window.location.reload();
      }}
      onClose={onClose}
    />
  );
};
